export default __webpack_public_path__ + "static/media/chevron-right.2e7c7197.svg";